import { render, staticRenderFns } from "./WineForm.vue?vue&type=template&id=925f0932"
import script from "./WineForm.vue?vue&type=script&lang=ts"
export * from "./WineForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports